import Oidc from "oidc-client"

// get actual language from local storage
var lang = "cs"
// we use cz for czech language, but SSO uses cs
if (localStorage.getItem("lang") && localStorage.getItem("lang") == "cz") {
  lang = "cs"
} else if (localStorage.getItem("lang")) {
  lang = localStorage.getItem("lang")
}

var mgr = new Oidc.UserManager({
  authority: process.env.VUE_APP_AUTHORITY,
  client_id: process.env.VUE_APP_CLIENT_ID,
  client_secret: process.env.VUE_APP_KEY,
  redirect_uri: process.env.VUE_APP_REDIRECT,
  response_type: "code",
  scope: "openid",
  post_logout_redirect_uri: process.env.VUE_APP_POSTLOGOUTREDIRECT,
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  silent_redirect_uri: process.env.VUE_APP_SILENTREDIRECT,
  accessTokenExpiringNotificationTime: 10,
  filterProtocolClaims: true,
  loadUserInfo: true,
  extraQueryParams: {
    //send ui language
    kc_locale: lang
  }
})

//Oidc.Log.logger = console;
//Oidc.Log.level = Oidc.Log.NONE;

// mgr.events.addUserLoaded(async function(user) {
//await store.dispatch("refreshUserInfo");
//await store.dispatch('ensureUserIsKnown');
// });

// mgr.events.addAccessTokenExpiring(function () {
//   // console.log('AccessToken Expiring：', arguments);
// });

// mgr.events.addAccessTokenExpired(function () {
//   mgr.signoutRedirect().then(function (resp) {
//     store.commit('set_user', null); //clear user details in vuex
//   }).catch(function (err) {
//     console.log(err)
//   })
// });

// mgr.events.addSilentRenewError(function () {
//   console.error('Silent Renew Error：', arguments);
// });

// mgr.events.addUserSignedOut(function () {
//   mgr.signoutRedirect().then(function (resp) {
//     store.commit('set_user', null); //clear user details in vuex
//   }).catch(function (err) {
//     console.log(err)
//   })
// });

// class SecurityService {

//   constructor(){
//     // console.log('Creating SecurityService instance')
//   }

//   async getUser () {
//     let self = this;
//     return new Promise((resolve, reject) => {
//       mgr.getUser().then(function (user) {
//         if (user == null) {
//           return resolve(null)
//         } else {
//           return resolve(user)
//         }
//       }).catch(function (err) {
//         console.log(err)
//         return reject(err)
//       });
//     })
//   }

//   signIn (returnToUrl) {
//     returnToUrl ? mgr.signinRedirect({ state: returnToUrl })
//         : mgr.signinRedirect();
//   }

//   signOut () {
//     var self = this;
//     mgr.signoutRedirect().then(function (resp) {
//       // console.log('signed out', resp);
//     }).catch(function (err) {
//       console.log(err)
//     })
//   }
// }

// let service = new SecurityService();

// export {service as default, mgr};

export default mgr
